module.exports = __webpack_public_path__ + "static/media/BannerStaking.84a958db.png";